import { withWorkspaceQuery } from '@/lib/api/workspaceScopedEndpoints';

export function scopedFetch(url: string, init?: RequestInit): Promise<Response> {
  let body: unknown;
  if (typeof init?.body === 'string') {
    try { body = JSON.parse(init.body); } catch { body = undefined; }
  }
  return globalThis.fetch(withWorkspaceQuery(url, body), init);
}
